module.exports = __webpack_public_path__ + "img/three3Blue.c4e01c8b.jpg";